import './global.css';

import errorLogger, {
  scopeType,
  bugsnagStagesEnum,
  BUGSNAG_STATUSES,
} from '@picsart/growth-rc/services/errorLogger';
import webVitals from '@picsart/rc/services/webVitals';
import { initDataDogRUM } from '@picsart/datadog-rum';
import { getContext } from '@/context';
import setup from '@/entry';
import { datadogConfiguration } from './consts/datadog';

initDataDogRUM(datadogConfiguration);

const BUGSNAG_API_KEY = import.meta.env.VITE_BUGSNAG_API_KEY;
const miniappName = import.meta.env.VITE_APP_MINIAPP_NAME || 'genai-studio-v2';
const appVersion = import.meta.env.VITE_APP_VERSION || '0.1.0';
const currentBranchName = import.meta.env.VITE_APP_CURRENT_BRANCH_NAME;
const deploymentBranchName = import.meta.env.VITE_APP_DEPLOYMENT_BRANCH_NAME;
const releaseBranchName = import.meta.env
  .VITE_APP_RELEASE_CANDIDATE_BRANCH_NAME;
const onlyAppVersion = import.meta.env.VITE_APP_ONLY_APP_VERSION_FOR_BUGSNAG;

// Initialize error logging (Bugsnag) if configured
if (
  miniappName !== 'miniapp-id' &&
  BUGSNAG_API_KEY &&
  currentBranchName &&
  (currentBranchName === deploymentBranchName ||
    currentBranchName === releaseBranchName)
) {
  // @ts-expect-error: legacy type error
  bugsnagStagesEnum[bugsnagStagesEnum.miniapp_name_stage] = `${miniappName}${
    /^\d+.\d+.\d+-beta.\d+$/.test(appVersion) ? '-stage' : ''
  }`;

  errorLogger
    .init({
      apiKey: BUGSNAG_API_KEY,
      releaseStage: bugsnagStagesEnum.miniapp_name_stage,
      appVersion: onlyAppVersion ? appVersion : `${miniappName}-${appVersion}`,
      scope: scopeType.miniapps,
      project: miniappName,
    })
    .catch((error) => errorLogger.trigger(error, BUGSNAG_STATUSES.ERROR));
}

// Setup the app
setup({ containerId: 'root' });

// Initialize web vitals
try {
  webVitals(
    window.location.href,
    miniappName,
    getContext().handlers.sendAnalytics
  );
} catch {
  // WebVitals initialization is non-critical
}
